import { render, staticRenderFns } from "./TermAndCondition.vue?vue&type=template&id=28a77681&scoped=true"
import script from "./TermAndCondition.vue?vue&type=script&lang=js"
export * from "./TermAndCondition.vue?vue&type=script&lang=js"
import style0 from "./TermAndCondition.vue?vue&type=style&index=0&id=28a77681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a77681",
  null
  
)

export default component.exports